// @flow
import { StandardResourceSection } from '../StandardResourceSection';
import { DbiList } from './DbiList';
import { DbiView } from './DbiView';

import type { Location, Match } from 'react-router-dom';

export const DbiSection = ({ match, }: { location: Location, match: Match }): React$Node => (
    <StandardResourceSection match={match} list={DbiList} view={DbiView} />
);